var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.message)?_c('b-alert',{staticClass:"schedule-message",attrs:{"show":"","fade":"","variant":"dark"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.message)}})]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }